import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import Header from 'Lib/Header'
import { Summary } from 'Lib/Subheader'
import Sticky from 'Lib/Sticky'
import { AccountsState, AccountsContext } from 'AccountsContext'
import {
  checkUserLogin,
  getQueryParams,
  isInDomain,
  getCookie,
  delete_cookie,
  getGtmId
} from 'AccountsUtils'
import HeaderNew from './components/HeaderNew'
import Router from './Router'
import {
  initializeClevertap,
  triggerClevertap,
  getCommonClevertapParams,
  redirectMobileView,
  appJSCallBack
} from './utils'
import { isInFlyinDomain } from 'AccountsUtils'
import { checkMobileDevice } from './utils/validator'
import 'Styles/app.scss'
import './assets/_index.scss'
import { deviceId } from './deviceIdUtils'

function handleMobilePageStartForAndroid() {
  try {
    const currentPath = window.location.pathname
    const baseTripsPath = '/m/accounts/trips'

    let pageType

    if (currentPath === baseTripsPath || currentPath === `${baseTripsPath}/`) {
      pageType = 'TRIP_LIST'
    } else if (
      currentPath.match(new RegExp(`^${baseTripsPath}/[^/]+$`)) &&
      !currentPath.includes('?')
    ) {
      pageType = 'TRIP_DETAILS'
    }

    if (
      pageType &&
      window.AndroidInterface &&
      typeof window.AndroidInterface.onPageStart === 'function'
    ) {
      window.AndroidInterface.onPageStart(pageType)
      console.log(`Called MobileApp.onPageStart with type: ${pageType}`)
    }
  } catch (error) {
    console.error('Error in handleMobilePageStart:', error)
  }
}

function handleMobilePageStartForIOS() {
  try {
    const currentPath = window.location.pathname
    const baseTripsPath = '/m/accounts/trips'

    let pageType

    if (currentPath === baseTripsPath || currentPath === `${baseTripsPath}/`) {
      pageType = 'TRIP_LIST'
    } else if (
      currentPath.match(new RegExp(`^${baseTripsPath}/[^/]+$`)) &&
      !currentPath.includes('?')
    ) {
      pageType = 'TRIP_DETAILS'
    }

    if (
      pageType &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers[pageType]
    ) {
      window.webkit.messageHandlers[pageType].postMessage('Checking Back')
      console.log(
        `Called webkit.messageHandlers.${pageType}.postMessage with message: "Checking Back"`
      )
    }
  } catch (error) {
    console.error('Error in handleMobilePageStartForIOS:', error)
  }
}

const App = props => {
  useEffect(() => {
    const gtmId = getGtmId()
    if (gtmId) TagManager.initialize({ gtmId })
    deviceId()
    const isMobileDevice = checkMobileDevice()
    if (isMobileDevice) {
      if (getCookie('selectedLanguage') == 'ar') {
        document.documentElement.setAttribute('dir', 'rtl')
      } else {
        document.documentElement.setAttribute('dir', 'ltr')
      }
      if (getCookie('ct-ab')) {
        delete_cookie('ct-ab')
      }
    }
    handleMobilePageStartForIOS()
    handleMobilePageStartForAndroid()
  }, [])
  window.androidData = window?.MobileApp
    ? JSON.parse(window?.MobileApp?.getAppSpecificData() || '{}')
    : {}
  return (
    <AccountsState>
      <AccountsView />
    </AccountsState>
  )
}

const AccountsView = withRouter(props => {
  const { match } = props
  const params = getQueryParams()
  const goBack = () => {
    appJSCallBack('moveToTripList')
    if (props.history.location.pathname === '/') {
      window.location.href = window.location.origin
    } else if (
      props.history.location.pathname.indexOf('/cancel') > -1 &&
      params.src === 'home' &&
      params.isMobileApp === 'true'
    ) {
      window.location.href = props.history.location.pathname.replace(
        '/cancel',
        '?src=home&isMobileApp=true'
      )
    } else if (
      props.history.location.pathname.indexOf('/cancel') > -1 &&
      params.src === 'home'
    ) {
      window.location.href = props.history.location.pathname.replace(
        '/cancel',
        '?src=home'
      )
    } else if (
      props.history.location.pathname.indexOf('/cancel') > -1 &&
      params.src !== 'home'
    ) {
      window.location.href = props.history.location.pathname.replace(
        '/cancel',
        ''
      )
    } else if (props.history.location.pathname.indexOf('/trips/') > -1) {
      if (checkUserLogin()) {
        if (params && params.src === 'home') {
          window.location.href = '/accounts/tripslist'
        } else {
          props.history.push('/m/accounts/trips')
        }
      } else {
        if (isInFlyinDomain()) {
          window.location.href = '/'
        } else {
          checkMobileDevice()
            ? props.history.push('/m/support')
            : props.history.push('/support')
        }
      }
    } else {
      props.history.goBack()
    }
  }
  const convertQuery = () => {
    try {
      let { search } = window.location
      search = search ? search.split('?')[1] : search
      search = search.split('&')
      search = search.reduce((init, item) => {
        const newInit = { ...init }
        const [key, value] = item.split('=')
        if (key) {
          newInit[key] = value
        }
        return newInit
      }, {})
      return search
    } catch (e) {
      console.error('query destructure error', e)
    }
  }
  const { accountsHeader, accountsSubHeader } = useContext(AccountsContext)
  const [containerLoaded, containerLoadingHandler] = useState(false)
  const [hideHeader, toggleHeader] = useState(false)
  let pageView
  let isApp = true

  useEffect(() => {
    redirectMobileView()
  }, [])

  useEffect(() => {
    setTimeout(() => {
      containerLoadingHandler(true)
    }, 500)
  }, [])

  useEffect(() => {
    initializeClevertap()
  }, [])

  useEffect(() => {
    const clevertapData = getCommonClevertapParams()
    clevertapData.event_type = 'support_button_viewed'
    triggerClevertap('Account', clevertapData)
    const query = convertQuery() || {}
    const toggleFlag =
      typeof query.MobileApp === 'boolean'
        ? query.MobileApp
        : query.MobileApp === 'true'

    const isAppFlag = params && params.isApp === 'true'

    if (isAppFlag) {
      if (typeof window.sessionStorage !== 'undefined') {
        try {
          sessionStorage.setItem('mobileApp', 'true')
        } catch (e) {
          console.error('Error setting sessionStorage', e)
        }
      }
      toggleHeader(isAppFlag)
    }
  }, [])
  useEffect(() => {
    handleMobilePageStartForAndroid()
    handleMobilePageStartForIOS()
  }, [props.history.location.pathname])

  if (containerLoaded) {
    let mobileApp =
      typeof window.sessionStorage !== 'undefined' &&
      sessionStorage.getItem('mobileApp')
    if (
      mobileApp === 'true' ||
      hideHeader ||
      (params && params.isApp === 'true')
    ) {
      if (
        window.location.pathname.includes('trips') ||
        window.location.pathname.includes('cancel')
      ) {
        isApp = true
      } else {
        isApp = false
      }
    }
  }

  pageView = (
    <React.Fragment>
      <Sticky>
        <If condition={!hideHeader && !isApp}>
          <If condition={isInDomain()}>
            <HeaderNew />
            <Else />
            {isInFlyinDomain() ? <HeaderNew /> : <Header />}
          </If>
        </If>
        <If condition={isApp}>
          <Summary
            title={accountsHeader}
            subtitle={accountsSubHeader}
            goBackNavigation={goBack}
          />
        </If>
      </Sticky>
      <Router match={match} />
    </React.Fragment>
  )

  return (
    <div
      style={{
        background: isInFlyinDomain() ? 'transparent' : '#efeff4',
        minHeight: '100vh'
      }}
    >
      {pageView}
    </div>
  )
})

export default App
